import React from "react";
import { useTranslation } from "react-i18next";
import { useToggleWishlistItem } from "../../hooks/useToggleWishlistItem";
import Icon from "../../../../../common/components/Icon/Icon";

interface WishlistToggleButtonProps {
  productId: number;
  className?: string; // Allow passing a custom class for contextual styling
}

const WishlistToggleButton: React.FC<WishlistToggleButtonProps> = ({
  productId,
  className,
}) => {
  const { t } = useTranslation();
  const {
    handleToggle,
    isInWishlist,
    isLoading: isTogglingWishlist,
  } = useToggleWishlistItem(productId);

  const wishlistTitle = isInWishlist
    ? t("wishlistToggleButton.removeFromWishlistTitle", "Remove from Wishlist")
    : t("wishlistToggleButton.addToWishlistTitle", "Add to Wishlist");

  return (
    <button
      className={`wishlist-toggle-button ${className || ""} ${
        isInWishlist ? "is-active" : ""
      }`}
      aria-label={wishlistTitle}
      title={wishlistTitle}
      onClick={handleToggle}
      disabled={isTogglingWishlist}
    >
      <Icon
        iconName={isInWishlist ? "heart-filled" : "heart-outline"}
        className={isInWishlist ? "icon--filled" : "icon--stroke-thick"}
      />
    </button>
  );
};

export default WishlistToggleButton;
